export default "__VITE_ASSET__YAXUwoh0__"